interface FetchOptions extends RequestInit {
  body?: any
}

interface SupercycleContext {
  proxyPathPrefix: string
}

interface SupercycleAppEmbed {
  context: SupercycleContext
}

declare global {
  interface Window {
    supercycleAppEmbed: SupercycleAppEmbed
  }
}

/**
 * Utility function for making requests to the Supercycle API
 * @param method HTTP method to use
 * @param path API endpoint path
 * @param options Additional fetch options
 * @returns Promise with JSON response
 */
async function supercycleFetch<T>(method: string, path: string, options?: FetchOptions): Promise<T> {
  if (!path.startsWith('/')) path = `/${path}`
  const { proxyPathPrefix } = window.supercycleAppEmbed.context

  const response = await fetch(proxyPathPrefix + path, {
    method,
    headers: { 'Content-Type': 'application/json' },
    ...options,
  })

  if (!response.ok) {
    throw new Error(`Supercycle API error: ${response.status} ${response.statusText}`)
  }

  return response.json()
}

export { supercycleFetch }